import {ADD_TO_CART,  CLEAR_CART,  REMOVE_FROM_CART,
  RESET_BILL,
  SET_BILL_ROWS,
  SET_BILL_TYPE,
  SET_CART_ITEMS_FROM_STORAGE,
  SET_CUSTOMER,
  SET_CUSTOMER_TYPE,
  SET_PAYMENT_METHOD,
  SET_TRANSPORT_DETAILS,
  SET_TRANSPORT_ENABLED,
  UPDATE_QUANTITY,
} from '../actionConstants';
import {clearCartStorage, getCartItemsByUserId, saveCartToStorage} from '../localStorage/localCartStorage';

// Add item to cart
export const addToCart = product => async dispatch => {
  dispatch({
    type: ADD_TO_CART,
    payload:product,
  });
};

// Remove item from cart
export const removeFromCart = ({productId, size}) => {
  return {
    type: REMOVE_FROM_CART,
    payload: {productId, size},
  };
};

export const updateQuantity = payload => {
  return {
    type: UPDATE_QUANTITY,
    payload,                   
  };
};

export const clearCart = userId => async dispatch => {
  clearCartStorage(userId); 
  dispatch({
    type: CLEAR_CART,
    payload: {userId},
  });
};

export const loadCartFromStorage = payload => async dispatch => {
  const storedCart = await getCartItemsByUserId(payload);
  dispatch({
    type: SET_CART_ITEMS_FROM_STORAGE,
    payload: storedCart,
  });
};
export const setCustomer = payload => ({
  type: SET_CUSTOMER,
  payload,
});

export const setPaymentMethod = payload => ({
  type: SET_PAYMENT_METHOD,
  payload,
});

export const setPaymentMode = payload => ({
  type: 'SET_PAYMENT_MODE',
  payload,
});

export const resetBill = () => ({
  type: RESET_BILL,
});

// ── Billing screen fields ───────────────────────────────────────────────
export const setBillType = payload => ({
  type: SET_BILL_TYPE,
  payload,
});

export const setCustomerType = payload => ({
  type: SET_CUSTOMER_TYPE,
  payload,
});

export const setTransportEnabled = payload => ({
  type: SET_TRANSPORT_ENABLED,
  payload,
});

export const setTransportDetails = payload => ({
  type: SET_TRANSPORT_DETAILS,
  payload,
});

export const setBillRows = payload => ({
  type: SET_BILL_ROWS,
  payload,
});
